import {Component, OnInit} from '@angular/core';
import { InputCustom } from '../../../../shared/components/input-custom/input-custom';
import { ButtonPrimary } from '../../../../shared/components/button-primary/button-primary';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../../core/services/toast/toast-service';
import { LoaderService } from '../../../../core/services/loader/loader-service';
import { KeyStorageUtil } from '../../../../shared/utils/keystorage';
import { UsuarioAPI } from '../../../../core/models/AuthModel';
import { environment } from '../../../../../enviroments/enviroment';

@Component({
  selector: 'app-login-page',
  imports: [InputCustom, ButtonPrimary, ReactiveFormsModule],
  templateUrl: './login-page.html',
  styleUrl: './login-page.css',
})
export class LoginPage implements OnInit{
  constructor(
    private auth: AuthService,
    private router: Router,
    private toastService: ToastService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    KeyStorageUtil.clear();
  }

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });
  loading = false;
  submitted = false;
  versionFromPkgJson = environment.version;

  handleLogin = () => {
    this.submitted = true;
    this.loginForm.markAllAsTouched();
    if (this.loginForm.invalid) {
      return;
    }
    this.loaderService.showLoader();
    this.auth
      .login(
        this.loginForm.value.username || '',
        this.loginForm.value.password || ''
      )
      .subscribe({
        next: (res) => {
          if (res.newUser === 'si') {
            this.toastService.showToast(
              'Estimad@ usuari@, usted no posee los permisos para el acceso a la plataforma. Favor ponerse en contacto con el administrador de sistema.',
              'error'
            );
            this.loaderService.hideLoader();
            return;
          }

          if (res.usuario.perfil.length === 0) {
            this.toastService.showToast(
              'Estimad@ usuari@, usted no posee un perfil asignado. Favor ponerse en contacto con el administrador de sistema.',
              'error'
            );
            this.loaderService.hideLoader();
            return;
          }

          KeyStorageUtil.setItem<string>('token', res.token);
          KeyStorageUtil.setItem<number>('exp', res.exp);
          KeyStorageUtil.setItem<UsuarioAPI>('usuario', res.usuario);
          KeyStorageUtil.setItem('inicioPrimeraVez', 'true');

          this.toastService.showToast(
            `Estimado ${
              res.usuario.username ? res.usuario.username : 'usuario'
            }, Bienvenido`,
            'success'
          );

          this.router.navigate(['/menu']);
        },
        complete: () => {
          this.loaderService.hideLoader();
        },
        error: () => {
          this.toastService.showToast(
            'Credenciales incorrectas. Inténtelo de nuevo.',
            'error'
          );

          this.loaderService.hideLoader();
        },
      });
  };
  get username() {
    return this.loginForm.get('username');
  }
  get password() {
    return this.loginForm.get('password');
  }
}
